import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-offcanvas',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offcanvas.component.html',
  styleUrls: ['./offcanvas.component.scss'],

})
export class OffcanvasComponent {
  @Input() side: 'left' | 'right' = 'left';
  @Input() isOpen = false;
  @Input() btnHeight = '50px';
  @Input() btnTop = '20px';
  @Input() iconClass = 'bi-list';
  @Input() activeIconClass = 'bi-x-lg';
  @Input() TitelText = '';

  toggle() {
    this.isOpen = !this.isOpen;
  }

  // Hilfsfunktion für den Animationsstatus
  get animationState() {
    return `${this.side}-${this.isOpen ? 'open' : 'closed'}`;
  }
}
